(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["_blocks"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coflo-bottom-signup')) {
    const cofloMobileFormStyles = `
      @media screen and (max-width: 749px) {
        :host {
          display: block !important;
          box-sizing: border-box;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
        }

        [data-testid="app-router"],
        [class*="_inline_"] {
          display: block !important;
          box-sizing: border-box;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
        }

        [class*="_formContainer_"],
        [class*="_noImage_"],
        [class*="_gridItemContent_"],
        [data-sizing="form-wrapper"],
        form {
          box-sizing: border-box !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
        }

        [class*="_formContainer_"] {
          margin-inline: 0 !important;
        }

        [class*="_gridItemContent_"] {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        form input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]),
        form select,
        form textarea,
        button[type="submit"] {
          box-sizing: border-box !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
        }
      }
    `;

    customElements.define('coflo-bottom-signup', class extends HTMLElement {
      connectedCallback() {
        this._cofloSetupFormWidths();
        if (!this.hasAttribute('data-fixed') || this._cofloSpacer) return;

        this._cofloSpacer = document.createElement('div');
        this._cofloSpacer.setAttribute('aria-hidden', 'true');
        this._cofloSpacer.setAttribute('data-coflo-signup-space', this.id);
        this._cofloSpacer.style.cssText = 'display:block;width:100%;height:0;flex:none;pointer-events:none;';
        document.body.appendChild(this._cofloSpacer);

        this._cofloUpdateSpace = () => {
          if (!this.isConnected || !this._cofloSpacer) return;
          this._cofloSpacer.style.height = `${Math.ceil(this.getBoundingClientRect().height)}px`;
        };

        this._cofloObserver = new ResizeObserver(this._cofloUpdateSpace);
        this._cofloObserver.observe(this);
        this._cofloUpdateSpace();
      }

      _cofloSetupFormWidths() {
        if (this._cofloFormObserver) return;
        this._cofloFormRoots = new Map();
        this._cofloFormObserver = new MutationObserver(() => this._cofloSyncFormRoots());
        this._cofloFormObserver.observe(this, { childList: true, subtree: true });
        this._cofloSyncFormRoots();

        customElements.whenDefined('shopify-forms-embed').then(() => {
          if (this.isConnected && this._cofloFormObserver) this._cofloSyncFormRoots();
        });
      }

      _cofloSyncFormRoots() {
        if (!this.isConnected || !this._cofloFormRoots) return;
        const hosts = new Set(this.querySelectorAll('shopify-forms-embed'));

        this._cofloFormRoots.forEach((entry, host) => {
          if (hosts.has(host)) return;
          entry.observer.disconnect();
          entry.style.remove();
          this._cofloFormRoots.delete(host);
        });

        hosts.forEach((host) => {
          const root = host.shadowRoot;
          if (!root || this._cofloFormRoots.has(host)) return;

          const style = document.createElement('style');
          style.setAttribute('data-coflo-mobile-form-width', '');
          style.textContent = cofloMobileFormStyles;
          const restoreStyle = () => {
            if (this.isConnected && this.contains(host) && root.querySelector('[data-testid="app-router"]') && style.parentNode !== root) {
              root.appendChild(style);
            }
          };

          const observer = new MutationObserver(restoreStyle);
          observer.observe(root, { childList: true, subtree: true });
          this._cofloFormRoots.set(host, { style, observer });
          restoreStyle();
        });
      }

      disconnectedCallback() {
        this._cofloFormObserver?.disconnect();
        this._cofloFormObserver = null;
        this._cofloFormRoots?.forEach((entry) => {
          entry.observer.disconnect();
          entry.style.remove();
        });
        this._cofloFormRoots = null;
        this._cofloObserver?.disconnect();
        this._cofloSpacer?.remove();
        this._cofloObserver = null;
        this._cofloSpacer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
